import { CHAINS } from '@emberswap/emberswap-sdk2/dist/constants'
import { Chain, configureChains, createConfig, CreateConfigParameters } from 'wagmi'
import { InjectedConnector } from 'wagmi/connectors/injected'
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect'
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc'
import { publicProvider } from 'wagmi/providers/public'
export type Client = ReturnType<typeof createConfig>

const { chains, publicClient }: CreateConfigParameters & { chains: Chain[] } = configureChains(
  [...(CHAINS as Chain[])],
  [
    jsonRpcProvider({
      rpc: (chain) => {
        if (chain.id !== 1) return null
        return {
          http: `https://api.securerpc.com/v1`,
          webSocket: `wss://api.securerpc.com/v1`,
        }
      },
    }),
    publicProvider(),
  ],
  { pollingInterval: 8_000,
    stallTimeout: 1_000
  }
)

export const client: Client = createConfig({
  publicClient,
  logger: {
    warn: null,
  },
  autoConnect: false,
  connectors: [
    new InjectedConnector({
      chains,
      options: {
        shimDisconnect: true,
      },
    }),
    new WalletConnectConnector({
      chains,
      options: {
        // qrcode: true,
        projectId: 'd5de9ac12e8ff5168a0278b21cd2799d',
        showQrModal: true,
      },
    }),
  ],
})
